import React, { useEffect, useState } from 'react';

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from 'chart.js';
import { getMeasurements } from '../../../../api/reports.api';

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);

export default function MeasurementCharts({ userId }) {
  const [list, setList] = useState([]);

  useEffect(() => {
    load();
  }, [userId]);

  const load = async () => {
    try {
      const res = await getMeasurements(userId);
      const measurements = res.data.measurements || [];

      // تضمین مرتب‌سازی
      measurements.sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );

      setList(measurements);
    } catch (err) {
      console.error('Error loading measurement chart:', err);
    }
  };

  if (!list.length)
    return (
      <p className="text-gray-500 text-sm">هنوز اندازه‌ای ثبت نشده است.</p>
    );

  const labels = list.map((m) =>
    new Date(m.createdAt).toLocaleDateString('fa-IR')
  );

  const makeDataset = (field, label, color) => ({
    labels,
    datasets: [
      {
        label,
        data: list.map((m) => m[field] || 0),
        borderColor: color,
        backgroundColor: color + '33',
        tension: 0.3,
        fill: true,
      },
    ],
  });

  return (
    <div className="space-y-8">
      <div className="bg-white p-4 rounded-xl shadow">
        <Line data={makeDataset('waist', 'دور کمر', '#3b82f6')} />
      </div>

      <div className="bg-white p-4 rounded-xl shadow">
        <Line data={makeDataset('hips', 'باسن', '#ec4899')} />
      </div>

      <div className="bg-white p-4 rounded-xl shadow">
        <Line data={makeDataset('chest', 'سینه', '#10b981')} />
      </div>

      <div className="bg-white p-4 rounded-xl shadow">
        <Line data={makeDataset('bicep', 'بازو', '#f59e0b')} />
      </div>
    </div>
  );
}
